export const IMAGE_TYPES = ['png', 'jpg', 'jpeg', 'webp', 'svg', 'gif', 'data:image', 'image']
export const VIDEO_TYPES = ['mp4', 'video/ogg', 'webm', 'quicktime', 'video']
export const AUDIO_TYPES = ['mp3', 'audio/ogg', 'ogg', 'wav', 'mpeg', 'oga', 'mp4', 'audio']
